// extracted by mini-css-extract-plugin
export default {"btnKnowMore":"ComponentMainButton_btnKnowMore__cJ12w","emptyBlock":"ComponentMainButton_emptyBlock__Zvb1M","deerIcon":"ComponentMainButton_deerIcon__tilYp"};